// Author information - Edit this file to update author details

export const authorInfo = {
  name: 'Heeloly Upasani',
  bio: `Author of "A Journey Within" is a reflection of the author's own ideas and the viewpoint of a teenage girl who, upon witnessing and experiencing the judgmental nature of people and their desire to shape others' lives for their own satisfaction, finds herself engulfed in a whirlwind of thoughts. Along with her mother, father, and brother, she resides in Surat, a city in Gujarat, India. Her passion for reading began in the school library, where she eagerly awaited library time to immerse herself in a new tale. She is a book lover who loves dogs and chocolate desserts. She is eager to pursue her writing career and is passionate about allowing readers to explore her small world, where she lets her imagination run wild.`,
  photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
  socialMedia: {
    instagram: 'https://www.instagram.com/authorheelolyupasani/',
    goodreads: 'https://www.goodreads.com/author/show/54936700.Heeloly_Upasani',
    twitter: 'https://x.com/heelolyupasani',
    facebook: '#',
    pinterest: '#',
    spotify: '#'
  },
  email: 'heelolyverse@gmail.com',
  newsletterLink: '#'
};

export const faqData = [
  {
    category: 'About My Writing',
    questions: [
      {
        question: 'How did you start writing?',
        answer: 'I initially began writing to share my opinions on topics that left me wandering. Eventually, I developed the habit of sitting and thinking, which ultimately helped shape who I am today.'
      },
      {
        question: 'Where do you get your inspiration for your books?',
        answer: "I never know where I find inspiration to write, but one thing is certain: even when I am working on other things, I continue to write because it has grown to be a significant aspect of who I am. When I'm not writing, I feel lost."
      },
      {
        question: "What's your writing process like?",
        answer: "As I'm more of a silent-environment type, I won't notice how quickly time passes if I'm writing in a quiet place. Additionally, a significant portion is depending on my draft's current situation."
      },
      {
        question: 'What are you currently writing?',
        answer: 'Through my newsletter and social media, you can get updates on my current draft.'
      },
      {
        question: 'Do you plan on writing in other genres?',
        answer: 'I am sticking to writing in the genre I have selected for the time being, but who knows what the future will bring.'
      },
      {
        question: 'Is your next book a series or a standalone?',
        answer: 'This information can be found on my website in the reading order section and on my social media accounts.'
      },
      {
        question: 'Are you a full-time author?',
        answer: "I'm not a full-time writer because I am a student."
      }
    ]
  },
  {
    category: 'Personal & Reading Preferences',
    questions: [
      {
        question: 'What genres do you enjoy reading?',
        answer: 'Thriller, mystery, romance, and fantasy.'
      },
      {
        question: 'What are your hobbies besides reading?',
        answer: 'I like to travel, listen to music, and watch my favourite shows.'
      }
    ]
  },
  {
    category: 'Bonus Content, Access & Extras',
    questions: [
      {
        question: 'Where can I read bonus content or exclusive extras?',
        answer: "You can read bonus content through my website's bonus section."
      }
    ]
  },
  {
    category: 'Community & Contact',
    questions: [
      {
        question: 'How can readers contact you?',
        answer: 'Readers can contact me through my social media handles or email me at heelolyverse@gmail.com'
      },
      {
        question: 'Do you have a reader group or community?',
        answer: 'Yes, you can click the link to become a member of my reader group.',
        hasLink: true,
        linkText: 'Join Reader Group',
        linkUrl: '#'
      },
      {
        question: 'Are you open to collaborations?',
        answer: "For the details, please email me. I'll review it and get back to you soon."
      }
    ]
  }
];
